import { createFileRoute, redirect } from '@tanstack/react-router'
import { ensureValidSession } from '@/lib/auth-session'
import { LoginForm } from '@/components/auth/login-form'

export const Route = createFileRoute('/login')({
  validateSearch: (search: Record<string, unknown>): { redirect?: string } => ({
    redirect: typeof search.redirect === 'string' ? search.redirect : undefined,
  }),
  beforeLoad: async () => {
    // Only bounce away from /login if the session has not been rejected by the
    // server; a client-cached but rejected session must be able to reach this
    // page. "Not rejected" is the honest strength: `ensureValidSession` checks
    // an access token against the server once and then reuses that answer until
    // the token changes, so this is not a fresh server check on every visit.
    const session = await ensureValidSession()
    // An already-authenticated visitor lands on the Today workspace.
    if (session) throw redirect({ to: '/dashboard' })
  },
  component: LoginPage,
})

function LoginPage() {
  const { redirect: redirectTo } = Route.useSearch()
  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/40">
      <LoginForm redirectTo={redirectTo} />
    </div>
  )
}
